
import { EventEmitter, Inject, Injectable, ViewContainerRef } from '@angular/core';
import { Observable,  Subject, forkJoin,  of,  } from 'rxjs';
import { map, tap, switchMap,catchError } from 'rxjs/operators';

import { PafListsService } from '../paf-lists.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Environment } from '../../Environment';
import { HttpClient } from '@angular/common/http';
import {
  PafSetting,
  SupplierStatut,
  DebugParam,
  ExtUser,
  IntUser,
  PS_Lib_Report_Et_Form_Result,
  Contact,
  Profil,
  TraceConnectParameters,
  ApiVersion,
  RseQuestion,
  RseQuestionsGroup,
  DocTyp,
  PafDocument,
  Civility,
  ApeCod,
  Family,
  LegalForm,
  WFMotif,
  Currency,
  Country,
  Department,
  IntUserStatut
} from '../../all-models';
import { AbstractControl, FormGroup, NgForm } from '@angular/forms';
import {SpinnerOverlayService} from '../spinner-overlay.service';
import {  PilotageEndelContainerLoaderEvent } from '../../all-directives';
import { ENV } from '../../env.token';
import calert from 'calerts';



@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  public alreadyLogged:boolean = false; //Propriete mise à vraie si, au rafraichissement de l'application, Azure est déjà connecté
  public debugParam: DebugParam = new DebugParam();
  public redirectToDefaultScreenAfterLogin: boolean = false;
  public apiSirenLastError: string;

  detailSupplierToolbarWidth:number = 780;

  //public listsSvc!: PafListsService;
  private labelsFr:  PS_Lib_Report_Et_Form_Result[] ;
  private labelsEn:   PS_Lib_Report_Et_Form_Result[];
  
  public get labels():   PS_Lib_Report_Et_Form_Result[] {
    return ((this.lngCod||'FR').toUpperCase()=='FR' ? this.labelsFr : this.labelsEn) || [];
  }
  private labelsLoadedSubject:Subject<PS_Lib_Report_Et_Form_Result[]> = new Subject<PS_Lib_Report_Et_Form_Result[]>();
  public onLabelLoaded:Observable<PS_Lib_Report_Et_Form_Result[]>=this.labelsLoadedSubject.asObservable();

  
  constructor(
    private http: HttpClient,
    @Inject(ENV) public pafEnvironment: Environment,
    private activatedRoute: ActivatedRoute,
    private spinnerSvc: SpinnerOverlayService,
    private router : Router,
    public  listsSvc: PafListsService) {
  }
  
  public get portalType(): string {
    return this.pafEnvironment ? this.pafEnvironment.portalType : '';
  }
  public get apiBaseUrl(): string {
    return this.pafEnvironment?.apiBaseUrl || '';
  }

  get logoIsSvg():boolean {
    return this.pafEnvironment.logo?.toLowerCase().indexOf('.svg')>0;
  }

  

  /********************************
   * Listes issues du référentiel
   */  
  pafSettings: (PafSetting & {_display?: string, _cbodisplay?: string})[] = [];
  supplierStatuts: (SupplierStatut & {_display?: string, _cbodisplay?: string})[] = [];
  lstProfils:(Profil & {_display?: string, _cbodisplay?: string})[]=[];
  docTyps:(DocTyp & {_display?: string, _cbodisplay?: string})[]=[];
  pafDocuments:(PafDocument & {_display?: string, _cbodisplay?: string})[]=[];
  rseQuestions:(RseQuestion & {_display?: string, _cbodisplay?: string})[]= [];
  rseQuestionsGroups:(RseQuestionsGroup & {_display?: string, _cbodisplay?: string})[]=[];
  apiVersion?: (ApiVersion  & {_display?: string, _cbodisplay?: string})= null;
  civilities?:(Civility & {_display?: string, _cbodisplay?: string})[]=null;
  countries?:(Country & {_display?: string, _cbodisplay?: string})[]=null;
  lstApeCods: (ApeCod & {_display?: string, _cbodisplay?: string})[]=[];
  legalForms: (LegalForm & {_display?: string, _cbodisplay?: string})[]=[];
  families:(Family & {_display?: string, _cbodisplay?: string})[]=[];
  wfMotifs: (WFMotif & {_display?: string, _cbodisplay?: string})[] = [];
  currencies: (Currency & {_display?: string, _cbodisplay?: string})[] = [];
  regions: (Department & {_display?: string, _cbodisplay?: string})[];
  departments: (Department & {_display?: string, _cbodisplay?: string})[];
  lstIntUserStatut: IntUserStatut[] = [];

  /**********************************/


  get defaultCurrency(): Currency | null {
    return this.currencies.find(c=>c.Cod=='EUR') || null;
  }

  public async getApiVersion():Promise<ApiVersion>{
    return new Promise<ApiVersion>(async (resolve,reject)=>{
      if (this.apiVersion==null){
        this.listsSvc.getApiVersion().subscribe({
          next:value=>{
            this.apiVersion=value;
            resolve(this.apiVersion);
          },
          error:reason=>{
            this.alertSubscriptionReject(`L'Api du portail fournisseur n'a pas pu être interrogée. Veuillez contacter l'administrateur du système.`);
          }
        });
      } else {
        resolve(this.apiVersion);
      }
    })
  }

  public allListLoadingsInProgress: boolean = false;

public reloadAllLists(): Observable<void> {

  if (this.allListsLoaded === true) {
    return of(void 0);
  }

  this.allListLoadingsInProgress = true;
  this.WindowLock(
    this.lngCod === 'EN'
      ? 'Loading application datas, please wait.'
      : "Chargement des données de l'application en cours"
  );

  return forkJoin([
    this.listsSvc.getResCodLabels('FR', 'COMMON'),
    this.listsSvc.getResCodLabels('EN', 'COMMON'),
    this.listsSvc.getPafSettings(),
    this.listsSvc.getSupplierStatuts(),
    this.listsSvc.getProfils(),
    this.listsSvc.getDocTyps(),
    this.listsSvc.getPafDocuments(),
    this.listsSvc.getCivilities(),
    this.listsSvc.getApeCods(),
    this.listsSvc.getFamilies(),
    this.listsSvc.getLegalForms(),
    this.listsSvc.getWFMotifs(),
    this.listsSvc.getCurrencies(),
    this.listsSvc.getCountries(),
    this.listsSvc.getRegions(),
    this.listsSvc.getDepartments(),
    this.listsSvc.getRseQuestions(),
    this.listsSvc.getRseQuestionsGroups(),
    this.listsSvc.getIntUsersStatuts()
  ]).pipe(
    tap((results: any[][]) => {
      this.labelsFr = results[0];
          this.labelsEn = results[1];
          this.pafSettings = results[2];
          this.supplierStatuts = results[3].filter(s=>!s.TopFerme);
          this.lstProfils = results[4].filter(p=> !!p.Actif);
          this.docTyps = results[5];
          this.pafDocuments = results[6];
          this.civilities = results[7];
          this.lstApeCods = results[8];
          this.families = results[9];
          this.legalForms = results[10];
          this.wfMotifs = results[11];
          this.currencies = results[12].filter(c=>c.Active==1);
          this.countries = results[13].filter(c=>c.Active==1);
          this.regions = results[14];
          this.departments = results[15];
          this.rseQuestions = results[16];
          this.rseQuestionsGroups = results[17];
          this.lstIntUserStatut = results[18];
          this.lstProfils.forEach(item=>{
            item._display=this.getLoadedLabel(item.LblCod);
            item._cbodisplay=this.getLoadedLabel(item.LblCod);;
          });
          this.docTyps.forEach(item=>{
            item._display=this.getLoadedLabel(item.LblCod);
            item._cbodisplay=`${item.Cod} - ${this.getLoadedLabel(item.LblCod)}`;
          });
          this.pafDocuments.forEach(item=>{
            item._display=this.getLoadedLabel(item.LblCod);
            item._cbodisplay=this.getLoadedLabel(item.LblCod);;
          });
          this.civilities.forEach(item=>{
            item._display=item.Cod;
            item._cbodisplay=`${item.Cod} - ${this.getLoadedLabel(item.LblCod)}`;
          });
          this.lstApeCods.forEach(item=>{
            item._display=`${item.Cod} - ${item.LblCod}`;
            item._cbodisplay=`${item.Cod} - ${item.LblCod}`;
          });
          //this.families.forEach(item=>item._display=this.getLoadedLabel(item.LblCod));
          this.legalForms.forEach(item=>{
            item._display=item.LblCod;
            item._cbodisplay=item.LblCod;
          });
          this.wfMotifs.forEach(item=>{
            item._display=this.getLoadedLabel(item.LblCod);
            item._cbodisplay=this.getLoadedLabel(item.LblCod);;
          });
          this.currencies.forEach(item=>{
            item._display=`${item.Cod} - ${item.LblCod}`;
            item._cbodisplay=`${item.Cod} - ${item.LblCod}`;
          });
          this.countries.forEach(item=>{
            item._display=item.LblCod;
            item._cbodisplay=`${item.CountryCod2} - ${item.LblCod}`;
          });
          this.regions.forEach(item=>{
            item._display=`${item.RegionName}`;
            item._cbodisplay=`${item.RegionName}`;
          });
          this.departments.forEach(item=>{
            item._display=`${item.DptName}`;
            item._cbodisplay=`${item.DptNumber} - ${item.DptName}`;
          });
          this.labelsLoadedSubject.next(this.labels);
          this.langChangeSubject.next(this.lngCod);
          this.allListsLoaded = true;
          this.WindowUnlock();
          this.allListsLoadedSubject.next(true);
    }),
    map(() => void 0),
    catchError(err => {
      this.WindowUnlock();
      this.allListLoadingsInProgress = false;
      throw err;
    })
  );
}



  public reloadAllLists_old():Observable<void> {    
    let subject :Subject<void> = new Subject<void>();
    if (this.allListsLoaded == true) {
      subject.next();
    } else {
      this.allListLoadingsInProgress = true
      this.WindowLock(this.lngCod=="EN" ? "Loading application datas, please wait." : "Chargement des données de l'application en cours")
      forkJoin({
                labelsFr: this.listsSvc.getResCodLabels('FR', 'COMMON'),
                labelsEn: this.listsSvc.getResCodLabels('EN', 'COMMON'),
                pafSettings: this.listsSvc.getPafSettings(),
                supplierStatuts: this.listsSvc.getSupplierStatuts(),
                profils: this.listsSvc.getProfils(),
                docTyps: this.listsSvc.getDocTyps(),
                pafDocuments: this.listsSvc.getPafDocuments(),
                civilities: this.listsSvc.getCivilities(),
                apeCods: this.listsSvc.getApeCods(),
                families: this.listsSvc.getFamilies(),
                legalForms: this.listsSvc.getLegalForms(),
                wfMotifs: this.listsSvc.getWFMotifs(),
                currencies: this.listsSvc.getCurrencies(),
                countries: this.listsSvc.getCountries(),
                regions: this.listsSvc.getRegions(),
                departments: this.listsSvc.getDepartments(),
              }
        // this.listsSvc.getRseQuestions(),
        // this.listsSvc.getRseQuestionsGroups(),      
      ).subscribe({
        next: results => {
          this.labelsFr = results.labelsFr;
          this.labelsEn = results.labelsEn;
          this.pafSettings = results.pafSettings;
          this.supplierStatuts = results.supplierStatuts.filter(s => !s.TopFerme);
          this.lstProfils = results.profils;
          this.docTyps = results.docTyps;
          this.pafDocuments = results.pafDocuments;
          this.civilities = results.civilities;
          this.lstApeCods = results.apeCods;
          this.families = results.families;
          this.legalForms = results.legalForms;
          this.wfMotifs = results.wfMotifs;
          this.currencies = results.currencies.filter(c => c.Active === 1);
          this.countries = results.countries.filter(c => c.Active === 1);
          this.regions = results.regions;
          this.departments = results.departments;
          // this.rseQuestions = results[16];
          // this.rseQuestionsGroups = results[17];
          this.lstProfils.forEach(item=>{
            item._display=this.getLoadedLabel(item.LblCod);
            item._cbodisplay=this.getLoadedLabel(item.LblCod);;
          });
          this.docTyps.forEach(item=>{
            item._display=this.getLoadedLabel(item.LblCod);
            item._cbodisplay=`${item.Cod} - ${this.getLoadedLabel(item.LblCod)}`;
          });
          this.pafDocuments.forEach(item=>{
            item._display=this.getLoadedLabel(item.LblCod);
            item._cbodisplay=this.getLoadedLabel(item.LblCod);;
          });
          this.civilities.forEach(item=>{
            item._display=item.Cod;
            item._cbodisplay=`${item.Cod} - ${this.getLoadedLabel(item.LblCod)}`;
          });
          this.lstApeCods.forEach(item=>{
            item._display=`${item.Cod} - ${item.LblCod}`;
            item._cbodisplay=`${item.Cod} - ${item.LblCod}`;
          });
          //this.families.forEach(item=>item._display=this.getLoadedLabel(item.LblCod));
          this.legalForms.forEach(item=>{
            item._display=item.LblCod;
            item._cbodisplay=item.LblCod;
          });
          this.wfMotifs.forEach(item=>{
            item._display=this.getLoadedLabel(item.LblCod);
            item._cbodisplay=this.getLoadedLabel(item.LblCod);;
          });
          this.currencies.forEach(item=>{
            item._display=`${item.Cod} - ${item.LblCod}`;
            item._cbodisplay=`${item.Cod} - ${item.LblCod}`;
          });
          this.countries.forEach(item=>{
            item._display=item.LblCod;
            item._cbodisplay=`${item.CountryCod2} - ${item.LblCod}`;
          });
          this.regions.forEach(item=>{
            item._display=`${item.RegionName}`;
            item._cbodisplay=`${item.RegionName}`;
          });
          this.departments.forEach(item=>{
            item._display=`${item.DptName}`;
            item._cbodisplay=`${item.DptNumber} - ${item.DptName}`;
          });
          this.labelsLoadedSubject.next(this.labels);
          this.langChangeSubject.next(this.lngCod);
          this.allListsLoaded = true;
          this.WindowUnlock();
          this.allListsLoadedSubject.next(true);
          subject.next();
          this.allListLoadingsInProgress = false
        }
        , error: (reason: any) => {
          this.WindowUnlock();
          this.allListLoadingsInProgress = false;
          subject.error(reason);
        }
        ,complete:()=>subject.complete()
      });

    }
    return subject.asObservable();
  }

  

  get rseMaxValue(): number {
    // let sumScoreQst:number =  this.rseQuestions.length==0 ? 0 : this.rseQuestions.map(q=>q.Score|0).reduce((sum,score)=>sum + (score|0));
    // let sumQualityDocs:number =  this.pafDocuments.length==0 ? 0 : this.pafDocuments.filter(d=>!!d.RseQualityDoc).map(d=>d.RseQualityDoc.Score|0).reduce((sum,score)=>sum + (score|0));
    // return sumScoreQst+sumQualityDocs;
    return 100;
  }


  

  private _PostExtUserByMail(email: string): Observable<ExtUser> {
    let searchParam: ExtUser = new ExtUser();
    searchParam.Email = email;
    return this.http.post<ExtUser>(`${this.apiBaseUrl}ExtUsers/ExtUserByMail`, searchParam);
  }

  private getCurrentDebugParam():Observable<DebugParam>{
    return this.http.get<DebugParam>(`${this.apiBaseUrl}Debug/Current`);
  }

  private _RetrieveByUid(uid: string): Observable<IntUser> {
    let intUser:IntUser=new IntUser();
    intUser.UtiGid = uid;
    intUser.AzureGid = uid;
    return this.http.post<IntUser>(`${this.apiBaseUrl}IntUsers/RetrieveByUid`,intUser);
  }

  public get debug(): boolean {
    return this.profil?.Cod && this.debugParam?.DebugActif == 1;
  }

  public get profil():Profil{
    if (this.debugParam?.DebugActif==1){
      return this.lstProfils.find(p=>p.Id==this.debugParam.ProfilId);
    } else {
      if (this.portalType=='EXTRANET'){
        return this.lstProfils.find(p=>p.Cod=='FOURNISSEUR');
      } else {
        //return this.lstProfils.find(p=>p.Id==this.loggedIntUser?.ProfilId);
        return this.loggedIntUser?.Profil;
      }
    }
  }



  
  public loggedProfilSubject:Subject<Profil>=new Subject<Profil>();
  public loggedProfilChange:Observable<Profil> = this.loggedProfilSubject.asObservable();
  public get showDebugButton(): boolean {
    return this.pafEnvironment?.debug || false;
  }

  public mainContainerRef:ViewContainerRef;
  
  private _loggedId?: string;
  public get loggedId(): string {
    return this._loggedId;
  }
  public set loggedId(value: string) {
    if (this._loggedId != value && value!=null) {
      // On teste le bon accès à l'Api avant de tout charger.
      this.getApiVersion().then(()=>{
        this.reloadAllLists().subscribe({
          next:()=>{
            this._affectLoggedIdAfterListLoaded(value);
          }
      });
      });
    } else {
      this._affectLoggedIdAfterListLoaded(value);
    }      
  }

  private _affectLoggedIdAfterListLoaded(value: string){
    if (this._loggedId != value || value==null) {
      if (this.portalType == 'EXTRANET') {
        this.dashboardAlreadyShown = false;
        if (!value) {
          this.loggedExtUser = null;
        } else {
          this._PostExtUserByMail(value)
            .subscribe((res: ExtUser) => {
              this.loggedExtUser = res;
            });
        }
      } else {
        if (!value) {
          this.loggedIntUser = null;
        } else {
          this._RetrieveByUid(value)
            .subscribe((res: IntUser) => this.loggedIntUser = res);
        }
      }
    }
  }


  redirectToDefaultScreen(forced?:boolean):void{
    if (forced == null) forced = false;
    if ((this.router?.url||'').indexOf('supplier-details')>=0 && !forced){
      return;
    }
    this.redirectToDefaultScreenAfterLogin=true;
    this.redirectOnConnect(this.profil);
  }

  redirectOnConnect(profil:Profil):void{
    this.loggedProfilSubject.next(profil);
    if (!this.redirectToDefaultScreenAfterLogin) return;
    
    this.WindowLock();
    setTimeout(() => {
    this.redirectToDefaultScreenAfterLogin = false;
    this.WindowUnlock();
    switch (profil?.Cod) {
      case 'ACH_OPERAT':
      case 'ACH_FAMHA':
      case 'COMPTA':
      case 'CTRL_QUAL':
        if (this.checkProfilAccessPafSettings('MY_TASKS')){
            this.router.navigate(['list-tasks']);
          } else {
            this.router.navigate(['locked-user']);
          }
        break;
      default:
        if (this.checkProfilAccessPafSettings('SUPPLIERS')){
            this.router.navigate(['suppliers']);
          } else {
            this.router.navigate(['locked-user']);
          }
    }
      
    }, 0);
  }

  private _loggedUserInfo?: any;
  public get userInfo():any {
    return this._loggedUserInfo;
  }
  public set userInfo(value:any){
    this._loggedUserInfo = value;
    this.loggedId = value ? value.sub : null;
  }
  private _loggedIntUser?: IntUser;
  public get loggedIntUser(): IntUser {
    return this._loggedIntUser;
  }
  public set loggedIntUser(intUser: IntUser) {
    if (this._loggedIntUser != intUser || intUser == null) {
      if (this.showDebugButton){
        this.getCurrentDebugParam().subscribe((debugParam:DebugParam)=>{
            this.debugParam = debugParam|| new DebugParam();
            this._loggedIntUser = intUser;      
            this._loggedIntUserSubject.next(intUser);
            this.loggedProfilSubject.next(this.profil);
            //if (intUser?.Contact) this.traceConnect(null,this.authToken,intUser.Contact);
        });
      } else {
        this.debugParam = new DebugParam();
        this._loggedIntUser = intUser;      
        this._loggedIntUserSubject.next(intUser);
        this.loggedProfilSubject.next(this.profil);
        //if (intUser?.Contact) this.traceConnect(null,this.authToken,intUser.Contact);
      }
    }
  }
  private _loggedIntUserSubject = new Subject<IntUser>();
  public loggedIntUserChange: Observable<IntUser> = this._loggedIntUserSubject.asObservable();
  private _loggedExtUser?: ExtUser;
  public get loggedExtUser(): ExtUser {
    return this._loggedExtUser;
  }
  public set loggedExtUser(extUser: ExtUser) {
    if (this._loggedExtUser != extUser) {
      this._loggedExtUser = extUser;
      this._loggedExtUserSubject.next(extUser);
      if (this.showDebugButton){
        this.getCurrentDebugParam().subscribe((debugParam:DebugParam)=>{
            this.debugParam = debugParam|| new DebugParam();
      this.loggedProfilSubject.next(this.profil);
      if (extUser?.Contact) this.traceConnect(null,this.authToken,extUser.Contact.Id);
        });
      } else {
        this.debugParam = new DebugParam();
      this.loggedProfilSubject.next(this.profil);
      if (extUser?.Contact) this.traceConnect(null,this.authToken,extUser.Contact.Id);
      }
    }
  }
  private _loggedExtUserSubject = new Subject<ExtUser>();
  public loggedExtUserChange: Observable<ExtUser> = this._loggedExtUserSubject.asObservable();

  public get loggedContact(): Contact | null {
    if (this.portalType == 'INTRANET' && this.loggedIntUser) {
      return this.loggedIntUser.Contact;
    } else if (this.portalType == 'EXTRANET' && this.loggedExtUser) {
      return this.loggedExtUser.Contact;
    } else {
      return null;
    }
  }

  public get loggedFirstName(): string {
    return this.loggedContact?.Firstname;
  }

  public get loggedLastName(): string {
    return this.loggedContact?.Lastname;
  }

  private langChangeSubject = new Subject<string>();
  public langChanged = this.langChangeSubject.asObservable();
  // private listsLoadedSubject = new Subject();
  // public listsLoaded = this.listsLoadedSubject.asObservable();
  private _lngCod: string = 'FR';
  public get lngCod(): string {
    return this._lngCod;
  }

  public allListsLoaded : boolean = false;
  private allListsLoadedSubject = new Subject<boolean>();
  public allListsLoadedChange: Observable<boolean> = this.allListsLoadedSubject.asObservable();
  

  public get allowedExtensions(): string[] {
    let values: string = this.pafSettings.find(item => item.KEY == "FILES_ALLOWED_EXTENSIONS")?.VALUE;
    if (values) {
      return values.toUpperCase().split(';');
    } else {
      return [];
    }
  }
  public get maxFileSize(): number {
    let value: string = this.pafSettings.find(item => item.KEY == "FILES_MAX_SIZE")?.VALUE;
    if (value) {
      return Number.parseInt(value);
    } else {
      return 1024 * 1024;
    }
  }
  public get ENVIRONMENT(): string {
    return this.pafSettings.find(item => item.KEY == "ENVIRONMENT")?.VALUE;
  }
  


  changeLanguage(value: string): void {
    if (value && value != this._lngCod) {
      this._lngCod = value;
      this.langChangeSubject.next(value);
    }
  }



  getLabels(resCod?: string, route?: ActivatedRoute): Observable<PS_Lib_Report_Et_Form_Result[]> {
    if (this.labels.length>0){
      return of(this.labels);
    } else { 
      return this.onLabelLoaded;
    }
    
  }
  getLoadedLabel(lblCod: string): string {
    let item : PS_Lib_Report_Et_Form_Result = (this.labels ||[]).find(i=> !!i.LblCod && i.LblCod.toLowerCase()==(lblCod||'').toLowerCase());
     return item?.LblLabel;    
  }

  getLabel(lblCod: String, resCod?: string, route?: ActivatedRoute): Observable<string> {
    return this.getLabels(resCod, route)
      .pipe(map((labels: PS_Lib_Report_Et_Form_Result[]) => {
        return (labels||[]).find(t => t.LblCod.toLowerCase() == lblCod.toLowerCase());
      }))
      .pipe(map((label:PS_Lib_Report_Et_Form_Result) => {
        if (!!label) {
          return label.LblLabel;
        }  else{
          return '???' + lblCod + '???';
        } 
      }));
  }

  public pafAlert(lblCod: string, nextCallBack: () => any = null, title:string = null) {
    //this.getCommonLabel(lblCod).subscribe(res => this.alert(res,nextCallBack));
    this.getLabel(lblCod, null, this.activatedRoute).subscribe(res => this.alert(res, nextCallBack, 'warning', title));
  }

  public pafInforme(lblCod: string, nextCallBack: () => any = null, title:string = null) {
    //this.getCommonLabel(lblCod).subscribe(res => this.alert(res,nextCallBack));
    this.getLabel(lblCod, null, this.activatedRoute).subscribe(res => this.alert(res, nextCallBack, 'success', title));
  }

  public informe(msg: string, nextCallBack: () => any = null, icon: any = 'success', title:string = null) {
    this.alert(msg, nextCallBack, 'success', title);
  }
  alertPending : boolean= false;
  public alert(msg: string, nextCallBack: () => any = null, icon: any = 'warning', title:string = null) {
    if (this.alertPending) return;
    this.alertPending = true;
    this.WindowUnlock();
    if (!title) {
      switch (icon) {
        case 'error':
          title = this.lngCod == 'FR' ? 'Erreur' : 'Error';
          break;
        case 'warning':
          title = this.lngCod == 'FR' ? 'Attention' : 'Warning';
          break;
        case 'success':
          title = '';
          break;
        default:
          title = this.lngCod == 'FR' ? 'Information' : 'Information';
      }
    }
    if (!msg) {
      msg = this.lngCod == 'FR' ? 'Une erreur inconnue est survenue.' : 'An unknown error has occurred.';
    }
    const htmlNode = calert.utils.tag("div", {
      innerHTML: `${msg}`
    });
     
    if (!nextCallBack) {
      calert({
        title: title,
        contentPosition: 'center',
        icon: icon,
        confirmButton: this.lngCod == 'FR' ? 'OK' : 'OK'
      }).then(()=> this.alertPending = false,()=> this.alertPending = false );
    } else {
      calert({
        title: title,
        contentPosition: 'center',
        icon: icon,
        confirmButton: this.lngCod == 'FR' ? 'OK' : 'OK',
      }).then((result) => {
        this.alertPending = false;
        if (result.isConfirmed) {
          nextCallBack();
        }
      },()=>{
        this.alertPending = false;
      });
    }
    this.injectHtml(`${msg}`);
  }


  public pafConfirm(lblCod: string, confirmCallBack: () => any, cancelCallback: () => any, title:string = null): void {
    //this.getCommonLabel(lblCod).subscribe(res => this.confirm(res, confirmCallBack,cancelCallback));
    this.getLabel(lblCod,null,this.activatedRoute).subscribe(res => this.confirm(res, confirmCallBack,cancelCallback, title));
  }

  public confirm(msg: string, confirmCallBack: () => any, cancelCallback: () => any, title:string = null): void {
      this.WindowUnlock();
      calert({
        title: title ? title : (this.lngCod=='FR' ? 'Confirmation' : 'Confirmation'),
        contentPosition: 'center',
        icon: 'question',
        confirmButton: this.lngCod=='FR' ? 'Oui' : 'Yes',
        cancelButton: this.lngCod == 'FR'?'Annuler': 'Cancel',
      }).then((result)=>{
        if (result.isConfirmed){
          if (confirmCallBack) confirmCallBack();
        } else if (result.isCanceled){
          if (cancelCallback) cancelCallback();
        }
      });
      this.injectHtml(`${msg}`);
  }

  private injectHtml(html: string) {
  setTimeout(() => {
    const content = document.querySelector('.ca-content-section');
    if (content) {
      content.insertAdjacentHTML("beforeend", html);
    }
  }, 0);
}


  public alertSubscriptionReject(reason: any, confirmCallack?:(value?:any | undefined) => any,icon: any = 'error'):void {
    let message : string = reason.message || reason.error?.Message || JSON.stringify( reason);
    
    if (typeof reason === 'string') {
      message = reason;
    }
    if (!message) return; 
    if (typeof reason.error === 'string') {
      message+= '<BR />' +'<BR />' + reason.error;
    }
    if (reason.status == 400 && !!reason?.error?.Message){
      message = reason?.error?.Message;
    } 
    if (reason?.error?.Message && reason.status != 400) {
      message+= `<BR/><small>${reason?.error?.Message}</small>`;
    }
    this.alert(message,confirmCallack, icon);
  }


  public pafPrompt(MsgCod: string, callbackFunction: (inputValue: string) => any): void {
    this.getLabel(MsgCod).subscribe(res => this.prompt(res, callbackFunction));
  }
  public prompt(msg: string, callbackFunction: (inputValue: string) => any) {
    calert({
      title: msg,
      inputs: {
        stringValue:{
          type: 'text'
        },
      },
      confirmButton: this.lngCod=='FR' ? 'OK' : 'OK',
      cancelButton: this.lngCod == 'FR'?'Annuler': 'Cancel',
    }).then((result)=>{
      if (result.isConfirmed && (<any>result.inputs)['stringValue']!=null) {
        callbackFunction((<any>result.inputs)['stringValue']);
      }
    });
  }

  public CanSave(f: any, noPrompt: boolean = false): boolean {
    let avecError: boolean = false;
    Object.keys(<NgForm>f.controls).forEach((key, i) => {
      let control: AbstractControl = f.controls[key];
      control.markAsTouched();
      if (control.errors != null) {
        avecError = true;
        return;
      }
    });
    if ((avecError || f.invalid) && !noPrompt) {
      this.pafAlert('Champs_en_erreur');
    }
    return !avecError;
  }

  //Variable utilisée par le Front Extranet
  public dashboardAlreadyShown: boolean = false;

  public WindowLock(message: string = ''):void{
    this.spinnerSvc.show(message)
  }
  public WindowUnlock():void{
    this.spinnerSvc.hide();
  }

  get profilLoaded():boolean{
    return !!(this.profil) && !!(this.profil.Cod);
  }
  
  get isAdmin():boolean {    
    return this.profil?.Cod=='ADMIN';
  }


  public RedirectToDefaultScreenIfNotAllowed(pafSettingKey:string):void{
    if (!this.profilLoaded) {
      this.loggedProfilChange.subscribe(p=>{
        if (p!=null){
          this.RedirectToDefaultScreenIfNotAllowed(pafSettingKey);
        }
      });
    } else {
      if (!this.checkProfilAccessPafSettings(pafSettingKey)){
        this.pafAlert('Msg_Acces_Ecran_Non_Autorise',()=> {
          this.redirectToDefaultScreen();
        });
      }
    }
  }

  public checkProfilAccessPafSettings(pafSettingKey:string):boolean {
    if (!this.profilLoaded) return false;
    if ((pafSettingKey||'').indexOf('ACCES_PROFILS/')!=0){
      pafSettingKey='ACCES_PROFILS/' + (pafSettingKey||'');
    }
    let profils: string[] = [];
    let pafSetting:PafSetting = this.pafSettings.find(p=>p.KEY==pafSettingKey)|| null;
    if (pafSetting!= null) {
      profils = pafSetting.VALUE.split(';');
    }
    if (profils.indexOf('*')>=0) return true; 
    return profils.some(s=>this.profil?.Cod==s);    
  }

  get canAccessTakapa():boolean {
    return this.checkProfilAccessPafSettings('TAKAPA');
  }
  get canAccessMyTasks():boolean {
    return this.checkProfilAccessPafSettings('MY_TASKS');
  }

  get canAccessNewSupplier():boolean {
    return this.checkProfilAccessPafSettings('NEW_SUPPLIER');
  }

  get canAccessSuppliers():boolean {
    return this.checkProfilAccessPafSettings('SUPPLIERS');
  }

  get canAccessDocLists():boolean {
    return this.checkProfilAccessPafSettings('DOC_LISTS');
  }

  get canAccessIntUsersAdmin():boolean {
    return this.checkProfilAccessPafSettings('INTERNAL_USERS');
  }

  get canAccessSourcing():boolean {
    return this.checkProfilAccessPafSettings('SOURCING');
  }
  public loadPilotageEndel : EventEmitter<PilotageEndelContainerLoaderEvent> = new EventEmitter<PilotageEndelContainerLoaderEvent>();

   //Evénement dclenché lorsqu'on active l'onglet Pilotage ENDEL
  //Permet d'alerter que l'onglet actif doit être rechargé (événement déclenché par la bibliothèque pour le front)
  public pilotageEndelIsActivated:EventEmitter<void> = new EventEmitter<void>();

  
  public formRevealErrors(f: NgForm | FormGroup, promptMessageErreur:boolean = false): boolean {
    let avecError: boolean = false;
    Object.keys(f.controls).forEach((key, i) => {
        let control: AbstractControl = f.controls[key];
        control.markAsTouched();
        try {
          control.updateValueAndValidity();
        } catch (e) { };
        
        if ( control.errors!=null) {
            if (!control.errors.intraTvaWarning){
                avecError = true;
                return;
            }
        }
    });
    if (avecError && promptMessageErreur){
      this.pafAlert('Champs_en_erreur');
    }
    return avecError;// || f.invalid;
  }

  private _authToken:string ='';
  get authToken():string{
    return this._authToken;
  }
  set authToken(value:string){
    if (value!=this._authToken){
      //Prevoir l'implémentation du tracage de connexion en base avec token = clé de contrôle et éventuellement clôturer la trace de l'ancienne connexion si non vide
      if (value && this.loggedContact) this.traceConnect(this._authToken,value,this.loggedContact?.Id);
      this._authToken = value;
    }
  }

  traceConnect(oldToken:string,newToken:string,contactId?:number):void{
    if ((oldToken||'')==(newToken||'')) return;
    let parameters:TraceConnectParameters = new TraceConnectParameters();
    parameters.ContactId = contactId;
    parameters.OldToken = oldToken;
    parameters.NewToken = newToken;
    parameters.PortalType = this.portalType;
    this.http.post<void>(`${this.apiBaseUrl}Contacts/traceConnection`, parameters).subscribe();
  }

  
  public highlightSearch(input: string, hightlightedValue: string): string {
    if (!input || !hightlightedValue) return input;
    let startIndex: number = input.toLowerCase().removeAccents().indexOf(hightlightedValue.toLowerCase().removeAccents());
    if (startIndex < 0) return input;

    let endIndex = startIndex + hightlightedValue.length;
    return [
      input.slice(0, startIndex),
      '<mark>',
      input.slice(startIndex, endIndex),
      '</mark>',
      input.slice(endIndex)
    ].join('');
  }
  
  
  
  public familyLevel(familyId: number): number {
     return this.listsSvc.familyLevel(familyId, this.families);
  }
  public familyLabel(familyId: number,addhierarchy: boolean = false): string {
    return this.listsSvc.familyLabel(familyId, this.families, addhierarchy);
  }
  public familyIcon(familyId: number): any {
    return this.listsSvc.familyIcon(familyId, this.families);
  }
  public familyIconClass(familyId: number): any {
    return this.listsSvc.familyIconClass(familyId, this.families);
  }
  public familyClass(familyId: number): any {
    return {
      "bg-primary text-white mw-100 mb-2": this.familyLevel(familyId) == 0,
      "text-primary small": this.familyLevel(familyId) == 1,
      "text-secondary small": this.familyLevel(familyId) == 2
    };
  }

  public clearServerCache(): Observable<void> {
    return this.listsSvc.clearServerCache(this.isAdmin).pipe(
      switchMap(() => {
        this.allListsLoaded = false;  
        return this.reloadAllLists();
      })
    );
  }
    
    public filterSettings: any = {
      caseSensitive: false,
      operator: "contains",
    };
  

}

